import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  useLinterDrawerContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/LinterDrawer/LinterDrawerContext';

const styles = theme => ({
  root: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: '-30px', // <--- Using negative margin over translate to maintain parent width
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  actionRequired: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: darken(theme.palette.error.main, 0.1),
    },
  },
  reviewWarnings: {
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: darken(theme.palette.warning.main, 0.1),
    },
  },
  reviewAlerts: {
    backgroundColor: theme.palette.disabled.main,
    '&:hover': {
      backgroundColor: darken(theme.palette.disabled.main, 0.1),
    },
  },
});

const AnalysisActionRequiredButton = ({
  className,
  classes,
  hasActionRequired,
  hasReviewableWarnings,
  hasAlerts,
}) => {
  const { pageContentResource } = usePageContentContext();

  const { openLinterDrawer } = useLinterDrawerContext();

  // Get button text / className
  let buttonText = 'View Alerts';
  let buttonClass = classes.reviewAlerts;
  if (hasReviewableWarnings) {
    buttonText = 'Review Warnings';
    buttonClass = classes.reviewWarnings;
  }
  if (hasActionRequired) {
    buttonText = 'Action Required';
    buttonClass = classes.actionRequired;
  }

  return (hasActionRequired || hasReviewableWarnings || hasAlerts) ? (
    <React.Fragment>
      <Button
        className={classNames(classes.root, buttonClass, className)}
        onClick={() => {
          openLinterDrawer(pageContentResource.attr('linterResults'));
        }}
        variant={'contained'}
        size={'medium'}
        round
        disableElevation
        test={'analysis-action-required-button'}
      >
        {buttonText}
      </Button>
    </React.Fragment>
  ) : null;
};

AnalysisActionRequiredButton.defaultProps = {
  className: '',
  hasActionRequired: false,
  hasReviewableWarnings: false,
  hasAlerts: false,
};

AnalysisActionRequiredButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hasActionRequired: PropTypes.bool,
  hasReviewableWarnings: PropTypes.bool,
  hasAlerts: PropTypes.bool,
};

export default withStyles(styles)(AnalysisActionRequiredButton);
